import { imageBase64 } from './ImageStore';

import { imageBase64Default } from './ImageStoreDefaults';

export const resetImageBase64 = () => {
	imageBase64.set(imageBase64Default);
};
